import { MdArrowLeft, MdArrowRight } from 'react-icons/md';
import { CustomArrowProps } from 'react-slick';

export function PrevArrow(props: CustomArrowProps) {
	return (
		<button
			onClick={props.onClick}
			className="w-6 h-6 z-10 left-0 -translate-y-1/2 top-1/2 absolute bg-primary-dark flex justify-center items-center text-white text-3xl"
			title="Voltar à imagem anterior"
		>
			<MdArrowLeft />
		</button>
	);
}
export function NextArrow(props: CustomArrowProps) {
	return (
		<button
			onClick={props.onClick}
			className="w-6 h-6 z-50 right-0 -translate-y-1/2 top-1/2 absolute bg-primary-dark flex justify-center items-center text-white text-3xl"
			title="Ir para a próxima imagem"
		>
			<MdArrowRight />
		</button>
	);
}
